import React from 'react';
import { ListGroupItem, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { format, parse } from 'date-fns';
import snakecaseKeys from 'snakecase-keys';

import {
  authorizedInstance as axios,
} from '~/utils';

const onMarkAsDone = (d) => {
  const payload = snakecaseKeys({
    data: {
      ...d,
      is_read: true,
    },
  }, { deep: true });

  axios
    .put(
      `/reminders/${d.id}`,
      payload,
    )
    .then(() => {
      window.location.reload(true);
    });
};

const ListGroupItemReminders = ({ data }) => (
  <ListGroupItem className="d-flex justify-content-between align-items-center">
    <span>
      <strong>{format(parse(data.reminderDate), 'MM/DD/YY')}</strong>{' '}
      {data.note}
    </span>

    <Button size="sm" color="tertiary" outline onClick={() => onMarkAsDone(data)}>
      <FontAwesomeIcon icon="check" />
      <span className="d-none d-md-inline pl-2"><span className="d-none d-xl-inline">Mark as </span>Done</span>
    </Button>
  </ListGroupItem>
);

ListGroupItemReminders.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

export { onMarkAsDone };
export default ListGroupItemReminders;
